import React, { useState } from "react";
import "./CustomDropDownStyle.css";

function CustomDropdown({
  items,
  onSelect,
  dropDownLabel,
  customLabelStyle,
  isDisabled,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [curSection, setCurSection] = useState("");

  const toggleDropdown = () => {
    if (!isDisabled) {
      setIsOpen((prev) => !prev);
    }
  };

  const handleItemClick = (item) => {
    setIsOpen(false);
    onSelect(item.value);
    setCurSection(item.value);
  };

  return (
    <div className="custom-dropdown" onMouseLeave={toggleDropdown} >
      <div
        className={`dropdown-label ${isDisabled ? "disabled" : ""}`}
        onClick={toggleDropdown}
        style={customLabelStyle}
      >
        <span>{dropDownLabel}</span>
        {!isDisabled && (
          <i
            className={`fa fa-chevron-down arrow-icon ${isOpen ? "rotate" : ""}`}
          ></i>
        )}
      </div>
      {isOpen && (
        <ul className="dropdown-menu">
          {items.map((item, idx) => (
            <li
              key={idx}
              className={`dropdown-item ${
                curSection === item.value ? "active" : ""
              }`}
              onClick={() => handleItemClick(item)}
            >
              {item.icon && <i className={`fa ${item.icon} item-icon`}></i>}
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomDropdown;
